<template>
  <div>
    <div class="row col-lg-12">
      <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
        <div class="form-group">
          <button class="btn btn-primary" @click="$emit('onSearchClick', values)">
            <i class="fa fa-play"></i>&nbsp;{{ $t('Search') }}
          </button>
          &nbsp;

          <button class="btn btn-default" @click="resetFilters">
            {{ $t('Reset') }}
          </button>
          &nbsp;

          <b-button
            v-if="!hideAdvancedBtn"
            :pressed="showFilters"
            title="Toggle advanced filter"
            variant="outline-secondary"
            @click="toggleFilters">
            <i class="fa fa-sliders-h"></i>&nbsp;{{ $t('Advanced') }}
          </b-button>

          <slot name="filter-buttons"></slot>
        </div>
      </div>
    </div>

    <advanced-filters
      :advanced-filters="filters"
      :show-advanced-filter="showFilters"
      :filters="filtersValues"
    ></advanced-filters>
  </div>
</template>

<script>
import AdvancedFilters from './AdvancedFilters.vue';
import Vue from "vue";

export default {
  components: {
    AdvancedFilters,
  },
  props: [
    'filters',
    'defaultValues',
    'expanded',
    'hideAdvancedBtn'
  ],
  data() {
    return {
      filtersValues: {},
      showFilters: false
    };
  },
  computed: {
    values() {
      let values = {};
      for (let key in this.filtersValues) {
        let value = this.filtersValues[key];
        let filter = this.getFilterConfig(key);
        if (filter.type === 'multiselect') {
          values[key] = value.map((el) => el[filter.trackBy])
        } else {
          values[key] = value;
        }
      }
      return values;
    },
  },
  methods: {
    getFilterConfig(key) {
        for (let i in this.filters) {
            if (this.filters[i].modelProp === key) {
                return this.filters[i];
            }
        }
        return null;
    },
    resetFilters() {
      this.setDefaults();
      this.$emit('onResetClick', this.values);
    },
    toggleFilters() {
        this.showFilters = !this.showFilters;
        this.$emit('onToggle');
    },
    setDefaults() {
      this.filtersValues = {};
      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.filtersValues, field, this.defaultValues[field]);
        }
      }
    }
  },
  mounted() {
    this.setDefaults();
    this.showFilters = !!this.expanded;
  },
}
</script>
